import { loginUrl } from './lib/redirect';

// Single source of the backend host, set at build time. REACT_APP_API_BASE_URL wins;
// REACT_APP_API_URL is what the prod build script passes (https://api.tezhal.uz).
// Neither set (or empty) -> test backend. Keep both as literal process.env.X
// references so CRA can inline them. The inner parentheses let the minifier fold
// ('https://api.tezhal.uz' || '<test>') even when REACT_APP_API_BASE_URL is unset,
// so the test host doesn't end up in the prod bundle. Callers' paths include /api.
export const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.REACT_APP_API_URL || 'https://tezhal-backend-vgc2hte.test.khorezmai.dev')
).replace(/\/+$/, '');

// Decode a JWT payload without a library. Returns null if it can't be parsed.
export function decodeToken(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    let b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    b64 += '='.repeat((4 - (b64.length % 4)) % 4);
    return JSON.parse(atob(b64));
  } catch {
    return null;
  }
}

// True only when the token is present and (if it carries an exp) not expired.
// If exp can't be read we optimistically allow it and let the server decide.
export function isTokenValid(token) {
  if (!token) return false;
  const payload = decodeToken(token);
  if (payload && payload.exp && Date.now() >= payload.exp * 1000) return false;
  return true;
}

// Clears the stored session and sends the user back to login. Used when the
// server reports 401 (expired/invalid token) so the admin can re-authenticate
// instead of being stuck on an error banner that a page refresh can't fix.
function handleSessionExpired() {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
  } catch {}
  if (window.location.pathname !== '/login') {
    // So'ralgan sahifa saqlanadi: qayta kirgandan keyin shu yerga qaytiladi.
    window.location.assign(loginUrl(window.location, 'expired=1'));
  }
}

// 🧪 Test muhit: Payme to'ldirishini simulyatsiya qilish (scenario: 'pay' | 'cancel_before').
// Backend prod'da 404 qaytaradi. Javob: { ok, status, data } — hech qachon throw qilmaydi
// (tarmoq xatosida status 0).
export async function simulatePaymeTopup(topupId, scenario, token) {
  try {
    const res = await apiFetch('/api/admin/test/payme-simulate', token, {
      method: 'POST',
      body: JSON.stringify({ topupId, scenario }),
    });
    const data = await res.json().catch(() => ({}));
    return { ok: res.ok, status: res.status, data };
  } catch {
    return { ok: false, status: 0, data: {} };
  }
}

export async function apiFetch(path, token, options = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(API_BASE_URL + path, {
    ...options,
    headers: { ...headers, ...(options.headers || {}) },
  });
  // A 401 from an authenticated admin call means the token is expired/invalid:
  // end the session cleanly so the user re-logs in and gets a fresh token.
  if (res.status === 401) {
    handleSessionExpired();
  }
  return res;
}
